import DashboardContainer from '../container/DashboardContainer';
import AppointmentContainer from '../container/AppointmentContainer';
import OPDQueueContainer from '../container/OPDQueueContainer';
import PatientContainer from '../container/PatientContainer';
import TaskContainer from '../container/TaskContainer';
import NotificationsContainer from '../container/NotificationsContainer';
import ProfileContainer from '../container/ProfileContainer';
import Patients from '../components/Patients/Patients';
import ViewPrescription from '../components/Patients/ViewPrescription/ViewPrescription';
import SelectClinicContainer from '../container/SelectClinicContainer';

export default [
  {
    title: 'Dashboard',
    component: DashboardContainer,
    url: '/',
    exact: true,
    auth: true,
  },
  {
    title: 'Dashboard',
    component: DashboardContainer,
    url: '/dashboard',
    exact: true,
    auth: true,
  },
  {
    title: 'OPD Queue',
    component: OPDQueueContainer,
    url: '/queue',
    exact: true,
    auth: true,
  },
  {
    title: 'OPD Queue',
    component: OPDQueueContainer,
    url: '/opd-queue',
    exact: true,
    auth: true,
  },
  {
    title: 'Appointments',
    component: AppointmentContainer,
    url: '/appointments',
    exact: true,
    auth: true,
  },
  {
    title: 'Tasks',
    component: TaskContainer,
    url: '/tasks',
    exact: true,
    auth: true,
  },
  {
    title: 'Patients',
    component: PatientContainer,
    url: '/patients',
    exact: true,
    auth: true,
  },
  {
    title: 'Notifications',
    component: NotificationsContainer,
    url: '/notifications',
    exact: true,
    auth: true,
  },
  {
    title: 'Profile',
    component: ProfileContainer,
    url: '/profile',
    exact: true,
    auth: true,
  },
  {
    title: 'ViewProfile',
    component: Patients,
    url: '/viewprofile',
    exact: true,
    auth: true,
  },
  {
    title: 'ViewProfile',
    component: Patients,
    url: '/viewprofile/:patientId',
    exact: true,
    auth: true,
  },
  {
    title: 'Patients',
    component: Patients,
    url: '/appointment/Patients/:appointmentId',
    exact: true,
    auth: true,
  },
  {
    title: 'ViewPrescription',
    component: ViewPrescription,
    url: '/viewpres',
    exact: true,
    auth: true,
  },
  {
    title: 'ViewPrescription',
    component: ViewPrescription,
    url: '/viewPrescription/:id',
    exact: true,
    auth: true,
  },
  {
    title: 'SelectClinic',
    component: SelectClinicContainer,
    url: '/select-clinic',
    exact: true,
    auth: true,
  },
];

